import "jquery-validation";
import { Fancybox } from "@fancyapps/ui";
// import RDStationService from "./RDStationService";

const fieldErrorClass = 'is-invalid';
export const telMessage = 'Por favor, forneça um telefone ou celular válido.';

export const nameValidateProps = {
  rules: {
    'nome': {
      minWords: 2
    }
  },
  messages: {
    'nome': {
      minWords: 'Por favor, forneça pelo menos nome e sobrenome.'
    }
  }
}

export const phoneValidateProps = {
  rules: {
    'telefone': {
      minlength: 14,
      maxlength: 15,
      'phoneBR': true
    }
  },
  messages: {
    'telefone': {
      minlength: telMessage,
      maxlength: telMessage
    }
  }
}

// Funcao para o campo que recebera / tera removida a classe de erro
function setHighlightEl(el) {
  if (el.hasClass('flexdatalist')) {
    return el.siblings('.flexdatalist-alias');
  }
  else if (el.is(':checkbox, :radio')) {
    return el.closest('.form-group').find('input:checkbox, input:radio');
  }
  return el;
}

// Funcao para remover tags, espaco e pontuacao
// De `jquery-validation/dist/additional-methods`
function stripHtml(value) {
  // Remove html tags and space chars
  return value.replace(/<.[^<>]*?>/g, " ").replace(/&nbsp;|&#160;/gi, " ")
    // Remove punctuation
    .replace(/[.(),;:!?%#$'\"_+=\/\-“”’]*/g, "");
}

// jQuery Validate Defaults
// Configuracoes padrao para todos os forms
jQuery.validator.setDefaults({
  errorElement: 'div',
  errorClass: 'invalid-feedback',
  focusInvalid: false,
  errorPlacement: function (error, element) {
    $(element).closest('.form-group').append(error);
    $(element).closest('.input-group').parent().append(error);
  },
  highlight: function (element) {
    let field = setHighlightEl($(element));
    field.addClass(fieldErrorClass);
  },
  unhighlight: function (element) {
    let field = setHighlightEl($(element));
    field.removeClass(fieldErrorClass);
  },
});

// Validacao de quantidade de palavras
// De `jquery-validation/dist/additional-methods`
jQuery.validator.addMethod("minWords", function (value, element, params) {
  return this.optional(element) || stripHtml(value).match(/\b\w+\b/g).length >= params;
}, jQuery.validator.format("Please enter at least {0} words."));

// Validacao de telefone
jQuery.validator.addMethod('phoneBR', function (phone_number, element) {
  phone_number = phone_number.replace(/\D/g, '');
  return this.optional(element) || phone_number.length <= 11 && phone_number.match(/^[1-9]{2}(?:[2-5]|9\d)(?!.*(\d)\1{6})[\d]{7}$/g);
}, telMessage);

// Mensagem padrao para campos obrigatorios
jQuery.extend(jQuery.validator.messages, {
  required: "Este campo é obrigatório.",
  email: "Por favor, forne&ccedil;a um endere&ccedil;o de email v&aacute;lido.",
  maxlength: jQuery.validator.format("Por favor, forne&ccedil;a n&atilde;o mais que {0} caracteres."),
  minlength: jQuery.validator.format("Por favor, forne&ccedil;a ao menos {0} caracteres."),
});

export default class ValidateService {
  constructor(options) {
    this.jquery = $;
    this.options = options;
  }

  /**
   * Mensagem de erro padrao
   * @param {boolean} invalidFields
   */
  static formMessageFail(invalidFields = true) {
    let messageTitle = invalidFields ? "Atenção" : "Erro ao enviar seus dados",
      messageText = invalidFields
        ? "Por favor, preencha os campos e verifique seus dados."
        : "Por favor, tente novamente mais tarde.";

    Fancybox.show(
      [
        {
          src: `<ion-icon class="i-size-3 text-danger mb-2" name="alert-circle-outline"></ion-icon><h3 class="h4 text-danger">${messageTitle}</h3><p class="font-size-lg">${messageText}</p>`,
          type: "html",
        },
      ],
      {
        mainClass: "form-message-wrapper",
      }
    );
  }

  /**
   * Mensagem de sucesso padrao
   * @param {JqueryElement} form
   * @param {boolean} isNewsletter
   */
  static formMessageSuccess(form, isNewsletter = false) {
    let messageTitle = isNewsletter ? "Parabéns!" : "Obrigado!";
    let messageText = isNewsletter
        ? "Agora você faz parte da nossa comunidade. <br>Nos encontraremos todas às quintas-feiras na sua caixa de entrada."
        : "Seus dados foram enviados. <br>Agradecemos o interesse e em breve retornaremos seu contato.";

    Fancybox.show(
      [
        {
          src: `<ion-icon class="i-size-3 text-primary mb-2" name="checkmark-circle-outline"></ion-icon><h3 class="h4 text-primary">${messageTitle}</h3><p class="font-size-lg">${messageText}</p>`,
          type: "html",
        },
      ],
      {
        mainClass: "form-message-wrapper",
        on: {
          destroy: (fancybox, slide) => {
            form.reset();
          },
        },
      }
    );
  }

  /**
   * Validação de formulário
   */

  validate() {
    const { jquery, options } = this;

    const formMessageFail = ValidateService.formMessageFail;
    const formMessageSuccess = ValidateService.formMessageSuccess;

    jquery(options.form).each(function () {
      $(this).validate({
        isNewsletter: options.isNewsletter,
        focusInvalid: options.focusInvalid,
        rules: options.rules,
        messages: options.messages,
        modalMessage: options.modalMessage,
        submitHandler: function (form) {
          if (options.customSubmitHandler) {
            options.customSubmitHandler();
            return;
          } else if (options.customSubmitHandler === false) {
            return null;
          }
          if (options.modalMessage) {
            formMessageSuccess(form, options.isNewsletter); // default submit
          }
          else {
            form.reset();
            Fancybox.close();
          }

          const downloadFile = $(form).data('download-file');
          if (downloadFile) window.open(downloadFile, 'blank');
        },
        invalidHandler: function (form, validator) {
          if (options.modalMessage) formMessageFail();
        },
      });
    })
  }
}
